import React from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import backArrow from "../../assets/images/arrow-left.png";

const BreadCrumbforback = ({ title, pageTitle, pageTitleRoute }: any) => {
  const location = useLocation();
  const navigate = useNavigate();

  const pathSegments = location.pathname.split("/").filter(Boolean);

  const handleBack = () => {
    navigate(-1);
  };
  return (
    <React.Fragment>
      <div
        className="page-title-box d-sm-flex align-items-center justify-content-between position-sticky "
        style={{ top: "70px", zIndex: "999" }}
      >
        <div style={{ display: "flex", gap: "10px ", alignItems: "center" }}>
          <img
          data-testing-id="backArrowrBreadcumBack"
            src={backArrow}
            alt=""
            onClick={handleBack}
            style={{ cursor: "pointer" }}
          />
          <h4 className="mb-sm-0">{title}</h4>
        </div>

        <div className="page-title-right">
          <ol className="breadcrumb m-0">
            <li className="breadcrumb-item fw-bold ">
              <Link to={pageTitleRoute}>
                <span style={{ color: "#808080" }}>{pageTitle}</span>
              </Link>
            </li>
            <li className="breadcrumb-item active fw-bold text-secondary">
              {title}
            </li>
          </ol>
        </div>
      </div>
    </React.Fragment>
  );
};

export default BreadCrumbforback;
